
import { defineComponent, reactive } from 'vue'

import Modal from '@/common/components/UI/Modal/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import useNotifications from '@/common/composable/useNotifications'
import { pvz } from '@/core/realisations/pvz.realisation'

export default defineComponent({
    components: { Modal, FileReader },
    props: {
        pvzId: {
            type: Number,
            required: true,
        },
        pvzName: {
            type: String,
            required: true,
        },
    },
    emits: ['create', 'update', 'cancel'],
    setup(props, { emit }) {
        const { notifyError, notify } = useNotifications()

        const state = reactive({
            files: [] as File[],
            is_loading: false,
        })

        const state_form$ = useVuelidate(
            {
                files: { required },
            },
            state
        )

        const emitCancel = () => {
            emit('cancel')
        }

        const uploadPhotos = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const form_data = new FormData()

                for (const file of state.files) {
                    form_data.append('photo[]', file)
                }

                await pvz.uploadPhoto(props.pvzId, form_data)
                notify({ title: 'Изображения загружены', type: 'success' })

                emitCancel()
            } catch (error) {
                notifyError({ error, title: 'При добавлении фото ПВЗ произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        return { state, state_form$, emitCancel, uploadPhotos }
    },
})
